import { apiClient } from "../apiClient";

export const roleApi = {
    getAll: () => apiClient.get(`role`),
    getSubSystem: (id: number) => apiClient.get(`role/${id}/sub-system`),
    getApis: (sub_system_id: number)=> apiClient.get(`api/sub-system/${sub_system_id}`),
    getApisSelected: (role_id: number,sub_system_id: number)=> apiClient.get(`role/${role_id}/sub-system/${sub_system_id}/api`),
    addApi: (role_id: number,api_id: number)=> apiClient.post(`role/${role_id}/api/${api_id}`),
    removeApi: (role_id: number,api_id: number)=> apiClient.delete(`role/${role_id}/api/${api_id}`),
    addSubsytem: (role_id: number,sub_system_id: number)=> apiClient.post(`role/${role_id}/sub-system/${sub_system_id}`),
    removeSubsystem: (role_id: number,sub_system_id: number)=> apiClient.delete(`role/${role_id}/sub-system/${sub_system_id}`),
}